import type { GetFormViewerTabGroupProps } from "./Viewer.type";

import { Typography, Space } from "antd";
import { t } from "i18next";

import { SEVERITY_GRID_FIELDS_COUNT } from "@/constants/Global";
import { TextEllipsis } from "@/ui/text-ellipsis";

const { Text } = Typography;

export const getFormViewerTabGroup = ({
  key,
  legend,
  fields = [],
  strongLabel = true,
}: GetFormViewerTabGroupProps) => {
  const UNFILLABLE_TYPES = ["label", "expression"];
  const inputs = fields.filter(
    (field) => !UNFILLABLE_TYPES.includes(field.props.schema.type)
  );

  /** @todo Remove severity grid condition after refactoring inputs count from template */
  const isSeverityGrid = legend === t("form:severityGrid.groupName");
  const inputCount = isSeverityGrid
    ? SEVERITY_GRID_FIELDS_COUNT
    : inputs.length;

  const filledInputCount = inputs.filter(
    (field) => field.props.isFilled === true
  ).length;

  return {
    key: String(key),
    label: (
      <Space>
        <TextEllipsis text={legend} length={15} strong={strongLabel} />
        <Text>
          ({filledInputCount}/{inputCount})
        </Text>
      </Space>
    ),
    children: fields,
  };
};
